import { PositionData, ClosedPositionsResponse, OpenPositionPayload, OpenPositionResponse } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Position API functions
 */

/**
 * Get open positions for a user
 */
export const getOpenPositions = async (userId: string, exchangeCode?: string): Promise<PositionData[]> => {
  return ApiClientManager.getPositionClient().getOpenPositions(userId, exchangeCode);
};

/**
 * Get closed positions for a user with pagination
 */
export const getClosedPositions = async (userId: string, limit: number = 10, skip: number = 0, exchangeCode?: string): Promise<ClosedPositionsResponse> => {
  return ApiClientManager.getPositionClient().getClosedPositions(userId, limit, skip, exchangeCode);
};

/**
 * Get position by ID
 */
export const getPositionById = async (userId: string, positionId: string): Promise<PositionData | null> => {
  return ApiClientManager.getPositionClient().getPositionById(userId, positionId);
};

/**
 * Open a new position for a user
 */
export const openPosition = async (payload: OpenPositionPayload): Promise<OpenPositionResponse | null> => {
  return ApiClientManager.getPositionClient().openPosition(payload);
};

